interface ErrorInfo {
  code: string;
  message: string;
}

export interface FileError {
  errors: ErrorInfo[];
  file: File;
}

export interface FileSuccess extends File {
  file: File;
}

enum FileType {
  SHEET = 'sheet',
  CSV = 'csv',
}

export type FileTypeMap = {
  [key: string]: FileType;
};

export const fileTypes: FileTypeMap = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': FileType.SHEET,
  'application/vnd.ms-excel': FileType.SHEET,
  'text/csv': FileType.CSV,
};
